
  import formatDistanceToNow from 'date-fns/formatDistanceToNow';
  import parseISO from 'date-fns/parseISO';

  export default {
    props: {
      datetime: { type: String, required: true }
    },
    computed: {
      timeAgo () {
        return formatDistanceToNow(parseISO(this.datetime));
      }
    }
  };
